import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import common from './modules/common'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    user
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore (module) {
      Object.keys(module).forEach((mod) => {
        // state[key] = _.cloneDeep(window.SITE_CONFIG['storeState'][key])
        if (mod === 'user') {
          let state = module[mod]
          Object.keys(state).forEach((key) => {
            if (typeof state[key] === 'boolean') {
              state[key] = false;
            } else if (typeof state[key] === 'string') {
              state[key] = '';
            } else if (typeof state[key] === 'object') {
              if (state[key] === null) {
                state[key] = null;
              } else if (Array.isArray(state[key])) {
                state[key] = [];
              } else {
                state[key] = {};
              }
            }
          })
        }
      })
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js